import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { COUNTDOWN_SECONDS } from '../utils/constants';
interface CountdownTimerProps {
  variant?: 'dark' | 'light';
}
export function CountdownTimer({
  variant = 'dark'
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown(COUNTDOWN_SECONDS);
  const bgClass = variant === 'dark' ? 'bg-red-700 text-white' : 'bg-white text-red-700';
  return <div className="flex items-center justify-center space-x-2 font-bold text-lg md:text-xl" data-id="element-50">
      <div className={`px-3 py-1 rounded-md shadow-sm ${bgClass}`} data-id="element-51">00</div>
      <span className={variant === 'dark' ? 'text-red-700' : 'text-white'} data-id="element-52">
        :
      </span>
      <div className={`px-3 py-1 rounded-md shadow-sm ${bgClass}`} data-id="element-53">
        {minutes}
      </div>
      <span className={variant === 'dark' ? 'text-red-700' : 'text-white'} data-id="element-54">
        :
      </span>
      <div className={`px-3 py-1 rounded-md shadow-sm ${bgClass}`} data-id="element-55">
        {seconds}
      </div>
    </div>;
}